import { create } from 'zustand';

type TooltipId = number | string | null;

type TooltipStoreState = {
  tooltipId: TooltipId;
};

type TooltipStoreActions = {
  setTooltipId: (id?: TooltipId) => void;
};

type TooltipStore = TooltipStoreState & TooltipStoreActions;

export const useTooltipStore = create<TooltipStore>((set) => ({
  tooltipId: null,
  setTooltipId: (id?: TooltipId) => set({ tooltipId: id }),
}));
